const state = {
	Ratings : []
}

const mutations = {
	SET_RATINGS : (state, payload) => {
		state.Ratings = payload
	},
}

const actions = {
	setRatings({commit}, payload) {
		commit('SET_RATINGS', payload)
	},
}

const getters = {
	getRatings : state => state.Ratings

}

export default {
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/RatingStore.js